import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-warning',
  template: `
    <div class="aid-layout-row aid-layout-gap-4">
      <div>
        <mat-icon
          svgIcon="alert_triangle"
          class="warning__icon"
          color="warn"
        ></mat-icon>
      </div>
      <span class="mat-small warning">{{
        message | translate | sentancecase
      }}</span>
    </div>
  `,
  styleUrls: ['./warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WarningComponent implements OnInit {
  @Input() message?: string;

  constructor() {}

  ngOnInit() {}
}
